import { createSelector } from '@reduxjs/toolkit';

// First select the relevant part from the state
export const selectToasterState = (state) => state.toaster;
export const selectToasterData = createSelector(selectToasterState, (state) => state.toasterList);
